import {React, useEffect, useState, useContext} from 'react'
import UrbanCommonSixItemsRetailPriceData from '../../../../Components/RuralAndUrbanCommonSixItemsRetailPriceData'
import { MyContextProvider } from "../../../../App";
import axios from "axios";
import { API_URL, getAuthHeaders, getUserClaimsForUi } from '../../../../Constant';
import { GlobalLoading, showLoading } from 'react-global-loading';
import {shortMonthToFull,handleUserLevelAccessPermissions,getAllYears,validateMonthYears,validateRoles} from '../../../../Custom/Custom'
import messages from '../.././../../assets/Messages.json'
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import titlesData from '../../../../titles.json';

function UrbanCommonSixItemsRetailPrice() {


        const [years, setYears] = useState([]);
        const [months, setMonth] = useState([]);
        const [yearName, setYearName] = useState('');
        const [monthName, setMonthName] = useState('');
        const [sectorCode, setSectorCode] = useState('');
        const [buttonAccess, setButtonAccess] =  useState({userLevel:'',roles:'',isVisible:false});
        const [urbanSixCommonItemPrice,setUrbanSixCommonItemPrice] = useState([])
        const [payload, setPayload] = useState([]);
        const token = useContext(MyContextProvider).token;
        const decode_token = getUserClaimsForUi();
        const navigate = useNavigate();
  
          const config = getAuthHeaders();





    useEffect(()=>{

      const level =  handleUserLevelAccessPermissions(decode_token);
      setButtonAccess(level)

        //Get all Months data    
     const getMonthsList = (e) => { 
      showLoading(true)
          axios
            .get(`${API_URL}api/graph/getMonths/2021`, config)
            .then((res) => {
              let monthDataResponse = res.data;
              if (monthDataResponse.status) {
                setMonth(monthDataResponse.data);
                showLoading(false)
              }
            })
            .catch((err) => {
              console.error(err);
             showLoading(false);
            });
        }


    const getYearList =()=>{
            setYears(getAllYears());
        }


     const pageLoadSixCommonItemPrices=()=>{
          showLoading(true);
          axios
          .get(`${API_URL}api/consumerRetail/getUrbanSixCommonItemPriceInputForm`, config)
          .then((res) => {
            let allData = res.data;
           if (allData.status) {
              setUrbanSixCommonItemPrice(allData.data[0].GroupCodes);
              showLoading(false)
              
            }
          }).catch((err)=>{
              console.log(err)
              showLoading(false);
          } );
  
  
        }


        const userRole = async () => { 
          showLoading(true);
      
          try {
              const role = await validateRoles(decode_token); 
              if (role) { 
                    getMonthsList();
                    getYearList();
                    pageLoadSixCommonItemPrices()
              } else {
                  alert("You are not an authorized user to capture the data for Pricing"); // Alert unauthorized user
                  navigate("/dashboard"); 
              }
          } catch (error) { 
              console.log(error); 
              showLoading(false); 
          }
      }
      
      userRole(); 

      },[])


      const handleDropdownChange=(e)=>{
         
        switch(e.target.name){
         case 'sector_code':
           setSectorCode('1')
         break;
         case 'month_name':
               setMonthName(e.target.value)
               setYearName('')
         break;
         case 'year_name':
            
              if(!validateMonthYears(e.target.value,monthName)){
                setMonthName('')
                setYearName('')
                return;
              }
              if(sectorCode===''){
                toast.error(messages.SECTOR_MSG, messages.COLOR_RED);
                setMonthName('')
                setYearName('')
                return;
              }

            if(monthName===''){
                  toast.error(messages.MONTH_MSG, messages.COLOR_RED);
                  setYearName('')
                  return;
              }
              setYearName(e.target.value)
        
              let postData={
                "sector_code": sectorCode,
                "month_name": monthName,
                "year_name": e.target.value
              }
              onChangeUrbanSixCommonItemPrice(postData)

                 
         break;
         default:
           console.log("switch case are not match");
        break;

        }
}








const onChangeUrbanSixCommonItemPrice= async (postData)=>{
 
    showLoading(true)
   try {
        const response = await axios.post(`${API_URL}api/consumerRetail/getUrbanSixCommonItemPriceInputFormData`, postData,config);
        if(response.data.status){
           setUrbanSixCommonItemPrice(response.data.data[0].GroupCodes)
           setPayload(response.data.data[1].payload)
           showLoading(false)
        }
       
      } catch (error) {
        console.error('Error posting data:', error);
        showLoading(false)
      }

}

const resetMothAndYearField=()=>{
  setMonthName('')
  setYearName('')

}

const storedLanguage = localStorage.getItem('language');
  return (
    <>
   
   <ToastContainer/>
   <GlobalLoading />
     <div className="container-fluid py-3">
      <div className="card mx-3 mb-3">
       <div className="card-body pb-1">
        <div className="row align-items-center">
            <h4 className="page_heading">{storedLanguage === 'hi' ? titlesData.hi.URBAN_SIX_COMMON_ITEM_PRICE : titlesData.en.URBAN_SIX_COMMON_ITEM_PRICE}</h4>
            <div className="row align-items-center">
               <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                    <label>{storedLanguage === 'hi' ? titlesData.hi.SECTOR_NAME : titlesData.en.SECTOR_NAME}</label>
                    <select
                     name="sector_code"
                     id="sector_code"
                     className="form-select"
                     onChange={handleDropdownChange}
                     value={sectorCode} 
                    >
                  <option value="" disabled>Select Sector</option>
                      <option  value="1">
                        Urban Six Common Items
                      </option>
                 </select>
                </div>

                <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                <label>{storedLanguage === 'hi' ? titlesData.hi.MONTH : titlesData.en.MONTH}</label>
                 <select  
                  name="month_name"
                  id="month_name"
                  className="form-select"  
                  onChange={handleDropdownChange} 
                  value={monthName}
                  >
                    <option value="" disabled>Select Month</option>
                      {months && months.map((ele, i) => (
                        <option key={i} value={ele.MONTH}>
                        {shortMonthToFull(ele.MONTH)}
                        </option>
                      ))}
                </select>
                </div>

                <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                <label>{storedLanguage === 'hi' ? titlesData.hi.CURRENT_YEAR : titlesData.en.CURRENT_YEAR}</label>
                    <select  
                     name="year_name" 
                     id="year_name"
                     className="form-select" 
                     onChange={handleDropdownChange}  
                      value={yearName} >
                        <option value="" disabled>Select Year</option>
                        {years && years.map((ele, index) => (
                          <option key={index} value={ele}>
                          {ele}
                          </option>
                        )) }
                  </select>
                </div>

              

               
            </div>
        </div>
      </div>
    </div>

    <div className="card mx-3 mb-3">
    {
           urbanSixCommonItemPrice.length > 0 && 
           <UrbanCommonSixItemsRetailPriceData 
           payload={payload}
            type="urban" 
            config={config} 
            resetMothAndYearField={resetMothAndYearField}  
            userInfoObject={buttonAccess} 
            sectorCode={sectorCode} 
            yearName={yearName} 
            monthName={monthName} 
            urbanAndRuralCommonItemPrice={urbanSixCommonItemPrice}
           />
        }
   </div>
    </div>
   
    </>
  )
}

export default UrbanCommonSixItemsRetailPrice